import React, { Component } from "react";

import PropTypes from "prop-types";

import { Grid } from "@mui/material";
import { withStyles } from "@mui/styles";
import Carousel from 'react-bootstrap/Carousel'

import styles from "./styles";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import team from "../../../assets/images/team.JPG";
import asiathumb from "../../../assets/images/asiathumb.png";
import team1 from "../../../assets/images/team1.png";
import team2 from "../../../assets/images/team2.png";
import team3 from "../../../assets/images/team3.png";
// import team4 from "../../../assets/images/team4.png";
import team5 from "../../../assets/images/team5.png";
import team6 from "../../../assets/images/team6.png";

import hatterene from "../../../assets/images/hatterene.png";
import indeedee from "../../../assets/images/indeedee.png";
import lilligant from "../../../assets/images/lilligant.png";
import torkoal from "../../../assets/images/torkoal.png";
import ferrothorn from "../../../assets/images/ferrothorn.png";
import mimikyu from "../../../assets/images/mimikyu.png";

import hatterene_s from "../../../assets/images/hatterene_s.png";
import indeedee_s from "../../../assets/images/indeedee_s.png";
import lilligant_s from "../../../assets/images/lilligant_s.png";
import torkoal_s from "../../../assets/images/torkoal_s.png";
import ferrothorn_s from "../../../assets/images/ferrothorn_s.png";
import mimikyu_s from "../../../assets/images/mimikyu_s.png";

import asiacup_plopy from "../../../assets/images/asiacup-plopy.png";
import asiacup_celes from "../../../assets/images/asiacup-celes.png";
import asiacup_melvin from "../../../assets/images/asiacup-melvin.png";
import asiacup_matthew from "../../../assets/images/asiacup-matthew.png";
import asiacup_evan from "../../../assets/images/asiacup-evan.png";
import asiacup_yoko from "../../../assets/images/asiacup-yoko.png";
import asiacup_brian from "../../../assets/images/asiacup-brian.png";

import sword from "../../../assets/images/sword.webp";
import shield from "../../../assets/images/shield.webp";

class Home extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      topButtonVisible: false,
      topTab1: '#FF5A34',
      topTab2: 'black',
      topTab3: 'black',
      topTab4: 'black',
      topTab5: 'black',
      topTab6: 'black',
      topTab7: 'black',
      monsTab1: '#FF5A34',
      monsTab2: 'black',
      monsTab3: 'black',
      monsTab4: 'black',
      monsTab5: 'black',
      monsTab6: 'black',
      index: 0,
      direction: null
    }
  }

  handleResize = (e) => {
    this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
  }

  toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop
    if (scrolled > 300) {
      this.setState({ topButtonVisible: true });
    }
    else if (scrolled <= 300) {
      this.setState({ topButtonVisible: false });
    }
  }

  scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
      /* you can also use 'auto' behaviour
         in place of 'smooth' */
    });
  };

  changeMainTabColour = (index, lastIndex) => {
    this.setState({ [`topTab${index + 1}`]: '#FF5A34', [`topTab${lastIndex + 1}`]: 'black' });
  }

  changeMonsTabColour = (index, lastIndex) => {
    this.setState({ [`monsTab${index + 1}`]: '#FF5A34', [`monsTab${lastIndex + 1}`]: 'black' });
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
    window.addEventListener('scroll', this.toggleVisible);
  }

  componentWillUnmount() {
    window.addEventListener("resize", this.handleResize);
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        <button style={{ display: this.state.topButtonVisible ? 'block' : 'none' }} onClick={this.scrollToTop} className={classes.topButton}>Top</button>
        <div className={classes.root}>
          <Grid container style={{ height: this.state.windowHeight / 1.5, backgroundColor: 'black' }}>
            <Grid xs={12} md={5}>
              <Carousel style={{ height: "100%", width: "100%", display: 'block' }} controls={false} indicators={false}>
                <Carousel.Item style={{ height: "100%", width: "100%", alignItems: 'center' }}>
                  <div
                    className="d-block"
                    style={{
                      minWidth: "175%",
                      height: (this.state.windowWidth < 960) ? this.state.windowHeight / 3 : this.state.windowHeight / 1.5,
                      backgroundImage: `url(${team})`,
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "top right",
                      filter: `blur(8px)`,
                    }}
                  />
                  <Carousel.Caption>
                    <h1 style={{ width: "200px", textAlign: 'left', color: 'white',textShadow: `1px 1px #000` }}><b>Pokémon Asia Cup 2021</b></h1>
                  </Carousel.Caption>
                </Carousel.Item>
              </Carousel>
            </Grid>
            <Grid xs={12} md={7} style={{ position: 'relative', display: 'inline-flex' }}>
              <div
                className="d-block"
                style={{
                  minWidth: "100%",
                  height: (this.state.windowWidth < 960) ? this.state.windowHeight / 3 : this.state.windowHeight / 1.5,
                  minHeight: "100%",
                  backgroundImage: `url(${team})`,
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                  // filter: `blur(5px)`,
                  // -webkit-filter: blur(8px);
                }}
              />

            </Grid>
          </Grid>

          <Tabs onSelect={(index, lastIndex) => this.changeMainTabColour(index, lastIndex)} style={{}}>
            <TabList style={{ textAlign: 'left', display: 'block', alignItems: 'left', padding: 64, paddingTop: 32, paddingBottom: 0, width: "100%" }}>
              <Tab id="mainTab1" style={{ color: this.state.topTab1 }}>Introduction                        <img src={torkoal} alt="torkoal" style={{ width: 40 }} />
              </Tab>
              <Tab id="mainTab2" style={{ color: this.state.topTab2 }}>Team Building Process</Tab>
              <Tab id="mainTab3" style={{ color: this.state.topTab3 }}>Team Overview</Tab>
              <Tab id="mainTab4" style={{ color: this.state.topTab4 }}>Usage Guide</Tab>
              <Tab id="mainTab5" style={{ color: this.state.topTab5 }}>Week 1</Tab>
              <Tab id="mainTab6" style={{ color: this.state.topTab6 }}>Week 2</Tab>
              <Tab id="mainTab7" style={{ color: this.state.topTab7 }}>Closing Thoughts</Tab>
            </TabList>

            <TabPanel>
              <Grid container xs={12} md={10}>
                <div style={{ padding: 64 }}>
                  <h1 style={{ textAlign: 'left' }}>Pokémon Asia Cup 2021:<br />Lilligant Shenanigans</h1><br />
                  <h2 style={{ textAlign: 'left' }}>Introduction</h2>
                  <p style={{ textAlign: 'left' }}>Hello everyone! I am <b>Kester Teh</b> (<a href="https://www.twitter.com/TehDrink" target="_blank" rel="noreferrer">@tehdrink</a> and formerly @KestyVGC). <br />In this report, I will be going through the team I used to achieve <b>Top 16</b> in the <a href="https://play.eslgaming.com/pokemon/asia/players-cup-2021" target="_blank" rel="noreferrer"><u>Pokémon Asia Players Cup 2021</u></a> and my run of both weekends.</p>
                  <h2 style={{ textAlign: 'left' }} >Biography</h2>
                  <p style={{ textAlign: 'left' }}>I first joined the competitive Pokémon community as a seniors division player in late 2015 and have waved Singapore’s flag in the Pokémon World Championships Day 2 in San Francisco and Anaheim in 2016 and 2017 respectively. When I entered the masters division, I played VGC19 and VGC20 and managed to get some small but big achievements such as Top 32 in the Victory Road Spring Cup 2020 and Top 16 in the Singapore Open II 2020. However, I’ve decided to shift my focus onto life and have been on and off Pokémon ever since. I now manage two YouTube channels and will be taking on my last school semester for a Diploma.</p>
                </div>
              </Grid>
            </TabPanel>
            <TabPanel>
              <Grid container xs={12} md={10}>

                <div style={{ padding: 64 }}>
                  <h2 style={{ textAlign: 'left' }}>Conceptualizing</h2>
                  <p style={{ textAlign: 'left' }}>
                    When the tournament was announced, I pondered on whether I could build a team quickly before the August 28th deadline. I had two weeks and I wanted to go in with a fresh team.<br /><br />

                    I hit up my teambuilding and practice buddy <b>Lewis Tan</b> (<a href="https://www.twitter.com/MultiBoyvgc" target="_blank" rel="noreferrer">@Multiboyvgc)</a> to think upon team ideas. Originally, I had wanted to play a Metagross-Entei core because it was quite a popular choice and that Entei is a good doggo. I also wanted to try out Coaching as it granted the target an Attack and Defence buff.<br /><br />
                  </p>
                  <img alt="team1" style={{ width: "80%", alignSelf: 'left', display: 'flex', marginBottom: 32 }} src={team1} />
                  <p style={{ textAlign: 'left' }}>
                    However, Lewis suggested some other ideas, which included a few Coalossal team concepts and we thought of the threats that would knock those teams down. One threat, in particular, the Torkoal-Venusaur game plan, caught our attention.<br /><br />

                    Named the brain-dead core, the fire and grass duo provide a wide range of support and damage options that lead to rage-inducing games.<br /><br />

                    While thinking of ways to defeat it, Lewis had a wild idea, which turned out to be the <b>Torkoal-Lilligant</b> core. This core was a popular choice on teams in VGC17 where it allowed Lilligant to After You Torkoal for it to Eruption quickly and to our surprise, Lilligant outspeeds Venusaur in terms of base Speed, allowing Torkoal to do big damage against Venusaur via After You+Eruption. It outspeeds the ün ün Regieleki when with sun up and also has higher Special Attack as compared to a Venusaur. Considering that the duo was considerably off the radar, we decided to build a team around it, since it beat our Venusaur-Torkoal threat.</p>
                  <hr />
                  <h2 style={{ textAlign: 'left' }}>Team Building Process</h2><br />
                  <p style={{ textAlign: 'left' }}>
                    We decided to attach Indeedee and Gigantamax Hatterene to the team off the bat. The duo makes a good Trick Room combination and also help in disrupting the opponent's moves. It was also added due to prior experience in building a Hattarene team for the Singapore Open II 2020 (Apparently Tobias Koschitzki won Malmö regionals with the same team, but had Gigantamax Butterfree instead of Gigantamax Venusaur).<br /><br />
                    Now, we just had to decide on the last two slots.<br /><br /></p>
                  <hr />
                  <h3 style={{ marginTop: 32, marginBottom: 32, textAlign: 'left' }}><b>Version 1: Incineroar and Conkeldurr</b></h3>
                  <img alt="team2" style={{ width: "80%", alignSelf: 'left', display: 'flex', marginBottom: 32 }} src={team2} />
                  <p style={{ textAlign: 'left' }}>

                    The threat of Glastrier came to mind and thus the duo were added to the team.<br /><br />

                    Incineroar is an awesome all-rounder that gives many utility options to boot. Intimidate lowers opposing Pokémon’s Attack stat, Fake Out gives turn pressure, Flare Blitz is a consistent damaging move, and Parting Shot gives pivot options. Additionally, it can also Parting Shot Hatterene if there ever is a need to switch it out in a scenario, though it does give a debuff to Incineroar.<br /><br />

                    Conkeldurr was a cool Pokémon that dealt big damage to Glastrier and Porygon2.<br /><br />
                  </p>
                  <h3 style={{ textAlign: 'left' }}>Calculations:</h3>
                  <hr />

                  <p style={{ textAlign: 'left' }}>
                    252+ Atk Guts Conkeldurr Drain Punch vs. 252 HP / 0 Def Glastrier: 180-212 (86.9 - 102.4%) -- 12.5% chance to OHKO<br /><br />
                    252+ Atk Guts Conkeldurr Drain Punch vs. 244 HP / 92 Def Eviolite Porygon2: 146-174 (76.4 - 91%) -- guaranteed 2HKO<br /><br />

                    However, Conkeldurr had some trouble due to inconsistent Flame Orb procs and was just bad in scenarios where it got damaged. Psychic terrain from Indeedee also halted it from picking up crucial Mach Punches against low health Pokémon.<br /><br />
                  </p>
                  <hr />
                  <h3 style={{ marginTop: 32, marginBottom: 32, textAlign: 'left' }}><b>Version 2: Conkeldurr gets kicked away by Glastrier</b></h3>
                  <img alt="team3" style={{ width: "80%", alignSelf: 'left', display: 'flex', marginBottom: 32 }} src={team3} />
                  <p style={{ textAlign: 'left' }}>
                    “Can’t beat em’? Join em’!” We tested Glastrier out to give more pressure over other Glastrier teams and add Ground-type coverage for the team since it was struggling with Coalossal. The horse packs a punch especially if Weakness Policy is proc-ed, is quite bulky defensively and has a low base Speed stat. After You from Lilligant also allows it to get free kills when given the chance and boosts its Attack for each kill via Chilling Neigh.<br /><br />
                  </p>
                  <hr />
                  <h3 style={{ marginTop: 32, marginBottom: 32, textAlign: 'left' }}><b>Version 3: Switching cat for cat, and adding a durian</b></h3>
                  <img alt="team5" style={{ width: "80%", alignSelf: 'left', display: 'flex', marginBottom: 32 }} src={team5} />
                  <p style={{ textAlign: 'left' }}>
                    I noticed that I hardly used Incineroar in games, and wanted a Pokémon that complements a Pokémon in the team. Liepard came to mind almost immediately due to its Copycat tech and just like that, it replaced the cat slot.<br /><br />

                    Porygon2 was still an issue even though we had Glastrier. It has an easy recovery option and can get annoying to deal with if its support/offensive options are still alive. Therefore, we replaced the horse with a durian, the king of fruits. There were two kinds of Ferrothorns to choose from, one offensive, one defensive based, but we chose to go for the defensive based one. Even though it only has a single attacking move, Body Press, Iron Defense on the Ferrothorn provides it with the capability to tank up physical attacks and also boost the power of Body Press, outright punishing Porygon2. Leech Seed and Protect also help it achieve its tanky role.This Ferrothorn variant also punishes opponents for not prioritising attacks onto it and also acts as a theoretical redirection.
                  </p>
                  <hr />
                  <h3 style={{ marginTop: 32, marginBottom: 32, textAlign: 'left' }}><b>Version 4: What you see today.</b></h3>
                  <img alt="team6" style={{ width: "80%", alignSelf: 'left', display: 'flex', marginBottom: 32 }} src={team6} />
                  <p style={{ textAlign: 'left' }}>
                    We quickly realised, through testing, that though the team packs a punch, we lacked utility options to let us escape scenarios. Liepard got shut down by Follow Me and quickly became a passive dead weight in the mid-game. Adding Mimikyu in its stead gave us better Trick Room options where Follow Me wasn’t needed and also offensive pressure via Swords Dance, Play Rough and Shadow Sneak.
                    Now, let's go in-depth into the team.
                  </p>
                </div>
              </Grid>
            </TabPanel>
            <TabPanel>
              <Grid container xs={12} md={10}>

                <div style={{ padding: 64 }}>
                  <img alt="asiathumb" style={{ width: this.state.windowWidth / 1.5 }} src={asiathumb} />
                  <h2 style={{ textAlign: 'left', marginTop: 32 }}>Team Overview</h2>
                  <Tabs onSelect={(index, lastIndex) => { this.changeMonsTabColour(index, lastIndex) }} style={{}}>
                    <TabList style={{ textAlign: 'left', alignItems: 'left', paddingTop: 32 }}>
                      <Tab style={{ display: 'flex', alignItems: 'center' }}>
                        <p id="monsTab1" style={{ marginTop: 'auto', verticalAlign: 'middle', display: 'contents', color: this.state.monsTab1 }}>Gmax Hatterene</p>
                        <img alt="hatterene" style={{ width: 40, height: 40 }} src={hatterene_s} />
                      </Tab>
                      <Tab style={{ display: 'flex', alignItems: 'center' }}>
                        <p id="monsTab2" style={{ marginTop: 'auto', verticalAlign: 'middle', display: 'contents', color: this.state.monsTab2 }}>Indeedee-F</p>
                        <img alt="indeedee" style={{ width: 40, height: 40 }} src={indeedee_s} />
                      </Tab>
                      <Tab style={{ display: 'flex', alignItems: 'center' }}>
                        <p id="monsTab3" style={{ marginTop: 'auto', verticalAlign: 'middle', display: 'contents', color: this.state.monsTab3 }}>Mimikyu</p>
                        <img alt="mimikyu" style={{ width: 40, height: 40 }} src={mimikyu_s} />
                      </Tab>
                      <Tab style={{ display: 'flex', alignItems: 'center' }}>
                        <p id="monsTab4" style={{ marginTop: 'auto', verticalAlign: 'middle', display: 'contents', color: this.state.monsTab4 }}>Ferrothorn</p>
                        <img alt="ferrothon" style={{ width: 40, height: 40 }} src={ferrothorn_s} />
                      </Tab>
                      <Tab style={{ display: 'flex', alignItems: 'center' }}>
                        <p id="monsTab5" style={{ marginTop: 'auto', verticalAlign: 'middle', display: 'contents', color: this.state.monsTab5 }}>Torkoal</p>
                        <img alt="torkoal" style={{ width: 40, height: 40 }} src={torkoal_s} />
                      </Tab>
                      <Tab style={{ display: 'flex', alignItems: 'center' }}>
                        <p id="monsTab6" style={{ marginTop: 'auto', verticalAlign: 'middle', display: 'contents', color: this.state.monsTab6 }}>Lilligant</p>
                        <img alt="lilligant" style={{ width: 40, height: 40 }} src={lilligant_s} />
                      </Tab>
                    </TabList>
                    <TabPanel>
                      <img alt="hatterene" style={{ display: 'flex', alignSelf: 'left', width: this.state.windowWidth / 4 }} src={hatterene} />
                      <p style={{ textAlign: 'left' }}>
                        <b>Hatterene</b> @ Life Orb <br />
                        Ability: Magic Bounce<br />
                        Level: 50<br />
                        Gigantamax: Yes<br />
                        EVs: 204 HP / 252 SpA / 52 SpD<br />
                        Quiet Nature<br />
                        IVs: 0 Atk / 0 Spe<br />
                        - Trick Room<br />
                        - Expanding Force<br />
                        - Dazzling Gleam<br />
                        - Mystical Fire<br /><br />
                        <b>Gigantamax Hatterene</b> gives big damage pressure to those unprepared for it. <br /><br />
                        <b>Trick Room</b> allows it to set up for other slow teammates to sweep. <br /><br />
                        <b>Expanding Force</b> provides good spread damage under <b>Psychic Terrain</b> and <b>Dazzling Gleam</b> covers for what Expanding Force can’t hit. <br /><br />
                        <b>Max Mindstorm</b> allows for terrain switches and does a good load of damage, especially when in psychic terrain.<br /><br />
                        <b>Gmax Smite</b> adds the confusion status onto the opponent’s field, allowing turn disruption and win conditions in bad match-ups or scenarios. It also does not overwrite terrain compared to Max Starfall, further allowing Indeedee and Hatterene to thrive on the field without priority threats.<br /><br />
                        <b>Mystical Fire</b> allows it to cripple Special Attackers when needed as well and it consistently destroys grass types such as Ferrothorn during its Gigantamax turns with <b>Max Flare</b>. <br /><br />
                      </p>
                      <h3 style={{ textAlign: 'left' }}>Calculations:</h3>
                      <hr />
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <h4 style={{ textAlign: 'left' }}>Defensive Calcs:</h4>
                        <img alt="shield" src={shield} style={{ width: 40 }} />
                      </div>
                      <p style={{ textAlign: 'left' }}>

                        +2 252+ SpA Moltres-Galar Max Darkness vs. 204 HP / 52 SpD Dynamax Hatterene-Gmax: 187-222 (59.1 - 70.2%) -- guaranteed 2HKO<br /><br />

                        252+ SpA Life Orb Celesteela Max Steelspike (130 BP) vs. 204 HP / 52 SpD Dynamax Hatterene: 257-304 (81.3 - 96.2%) -- guaranteed 2HKO<br /><br />

                        252+ SpA Venusaur-Gmax Sludge Bomb vs. 204 HP / 52 SpD Hatterene: 132-156 (83.5 - 98.7%) -- guaranteed 2HKO(edited)<br /><br />
                      </p>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <h4 style={{ textAlign: 'left' }}>Offensive Calcs:</h4>
                        <img alt="sword" src={sword} style={{ width: 40 }} />
                      </div>
                      <p style={{ textAlign: 'left' }}>
                        252+ SpA Life Orb Hatterene Max Mindstorm (130 BP) vs. 172 HP / 4 SpD Rillaboom-Gmax in Psychic Terrain: 281-331 (142.6 - 168%) -- guaranteed OHKO<br /><br />
                      </p>
                      <hr />
                    </TabPanel>
                    <TabPanel>
                      <img alt="indeedee" style={{ display: 'flex', alignSelf: 'left', width: this.state.windowWidth / 4 }} src={indeedee} />
                      <p style={{ textAlign: 'left' }}>
                        <b>Indeedee-F</b> @ Safety Goggles<br />
                        Ability: Psychic Surge<br />
                        Level: 50<br />
                        EVs: 252 HP / 196 Def / 60 SpD<br />
                        Bold Nature<br />
                        IVs: 0 Atk / 29 Spe<br />
                        - Follow Me<br />
                        - Expanding Force<br />
                        - Helping Hand<br />
                        - Protect<br /><br />

                        <b>Indeedee</b> is a great Pokémon known for its arsenal of support moves and ability. It provides <b>Follow Me</b> redirection support, <b>Helping Hand</b> to further boost attacks and <b>Expanding Force</b> for good chip in and out of terrain. <b>Protect</b> helps it survive predicted targets and stall turns when needed. <b>Psychic Surge</b> also helps boost Hatterene’s moves and also blocks priority moves from hitting the team, making it a vital Pokémon that makes the team work out.
                      </p>
                      <h3 style={{ textAlign: 'left' }}>Calculations:</h3>
                      <hr />

                      <p style={{ textAlign: 'left' }}>

                        - 29 IVs in speed helps it underspeed minimal speed Rillaboom at 31ivs and neutral nature considering they have the same base Speed stat.
                        - The set was made to survive opposing Gigantamax Hatterene’s Gmax Smite in the case of a mirror.
                      </p>

                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <h4 style={{ textAlign: 'left' }}>Defensive Calcs:</h4>
                        <img alt="shield" src={shield} style={{ width: 40 }} />
                      </div>
                      <p style={{ textAlign: 'left' }}>

                        252+ SpA Life Orb Hatterene Max Starfall (130 BP) vs. 252 HP / 60 SpD Indeedee-F: 148-175 (83.6 - 98.8%) -- guaranteed 2HKO

                        252+ SpA Spectrier Hyper Beam vs. 252 HP / 60 SpD Indeedee-F: 92-109 (51.9 - 61.5%) -- guaranteed 2HKO
                      </p>
                      <hr />
                    </TabPanel>
                    <TabPanel>
                      <img alt="mimikyu" style={{ display: 'flex', alignSelf: 'left', width: this.state.windowWidth / 4 }} src={mimikyu} />
                      <p style={{ textAlign: 'left' }}>
                        <b>Mimikyu</b> @ Mental Herb<br />
                        Ability: Disguise<br />
                        Level: 50<br />
                        EVs: 196 HP / 228 Atk / 84 Def<br />
                        Adamant Nature<br />
                        - Trick Room<br />
                        - Play Rough<br />
                        - Shadow Sneak<br />
                        - Swords Dance<br /><br />

                        <b>Mimikyu</b> provides an effortless <b>Trick Room</b> option due to its typing and ability, <b>Disguise</b>. Attaching a <b>Mental Herb</b> prevents it from being neutralised by a single <b>Taunt</b> and it adds to the Pokémon’s versatility. <b>Swords Dance</b> further boosts Mimikyu’s pressure and help it deal quick chips for its buddies to sweep using <b>Shadow Sneak</b> or <b>Play Rough</b>. Though, it can become passive under <b>Trick Room</b> turns under different scenarios.
                      </p>

                      <h3 style={{ textAlign: 'left' }}>Calculations:</h3>
                      <hr />

                      <p style={{ textAlign: 'left' }}>
                        Mimikyu was set in a way such that more EVs would be given to its HP and Def stats.
                        We went with 228 EVs instead of 244 EVs for its Attack stat as the percentage of killing Rillaboom was marginal.
                      </p>

                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <h4 style={{ textAlign: 'left' }}>Offensive Calcs:</h4>
                        <img alt="sword" src={sword} style={{ width: 40 }} />
                      </div>
                      <p style={{ textAlign: 'left' }}>

                        +2 228+ Atk Mimikyu-Busted Shadow Sneak vs. 252 HP / 4 Def Rillaboom: 63-75 (30.4 - 36.2%) -- guaranteed 4HKO after Grassy Terrain recovery<br /><br />

                        +2 228+ Atk Mimikyu-Busted Play Rough vs. 252 HP / 4 Def Rillaboom: 139-165 (67.1 - 79.7%) -- guaranteed 2HKO after Grassy Terrain recovery<br /><br />
                      </p>

                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <h4 style={{ textAlign: 'left' }}>Defensive Calcs:</h4>
                        <img alt="shield" src={shield} style={{ width: 40 }} />
                      </div>
                      <p style={{ textAlign: 'left' }}>

                        252+ SpA Torkoal Heat Wave vs. 196 HP / 0 SpD Mimikyu in Sun: 73-87 (47 - 56.1%) -- 76.2% chance to 2HKO
                      </p>
                      <hr />
                    </TabPanel>
                    <TabPanel>
                      <img alt="ferrothorn" style={{ display: 'flex', alignSelf: 'left', width: this.state.windowWidth / 4 }} src={ferrothorn} />
                      <p style={{ textAlign: 'left' }}>

                        <b>Ferrothorn</b> @ Leftovers<br />
                        Ability: Iron Barbs<br />
                        Level: 50<br />
                        EVs: 212 HP / 196 Def / 100 SpD<br />
                        Impish Nature<br />
                        - Body Press<br />
                        - Iron Defense<br />
                        - Leech Seed<br />
                        - Protect<br /><br />

                        The spiky boi here is an awesome slow tank by nature. This set, in particular, allows for <b>Ferrothorn</b> to win games where threats are gone and punish passive and stall teams. It counters big threats like Porygon2, Glastrier and rivals opposing Ferrothorns if it comes down to a timer stall.
                      </p>
                      <h3 style={{ textAlign: 'left' }}>Calculations:</h3>
                      <hr />

                      <p style={{ textAlign: 'left' }}>
                        - Made Ferrothorn able to OHKO the average Incineroar with a single Iron Defense boost.<br /><br />
                        - Made Ferrothorn 31 IVs in speed such that it will outspeed Torkoal and minimum speed Glastrier.
                      </p>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <h4 style={{ textAlign: 'left' }}>Offensive Calcs:</h4>
                        <img alt="sword" src={sword} style={{ width: 40 }} />
                      </div>
                      <p style={{ textAlign: 'left' }}>
                        +2 196+ Def Ferrothorn Body Press vs. 236 HP / 4 Def Incineroar: 210-248 (105 - 124%) -- guaranteed OHKO<br /><br />
                        +2 196+ Def Ferrothorn Body Press vs. 252 HP / 252 Def Stakataka: 180-212 (107.1 - 126.1%) -- guaranteed OHKO<br /><br />
                      </p>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <h4 style={{ textAlign: 'left' }}>Defensive Calcs:</h4>
                        <img alt="shield" src={shield} style={{ width: 40 }} />
                      </div>
                      <p style={{ textAlign: 'left' }}>

                        252+ SpA Magnet Transistor Regieleki Thunderbolt vs. 252 HP / 36+ SpD Ferrothorn: 49-58 (27 - 32%) -- guaranteed 4HKO<br /><br />
                      </p>
                      <hr />
                    </TabPanel>
                    <TabPanel>
                      <img alt="torkoal" style={{ display: 'flex', alignSelf: 'left', width: this.state.windowWidth / 4 }} src={torkoal} />

                      <p style={{ textAlign: 'left' }}>

                        <b>Torkoal</b> @ Charcoal<br />
                        Ability: Drought<br />
                        Level: 50<br />
                        EVs: 252 HP / 252 SpA / 4 SpD<br />
                        Quiet Nature<br />
                        IVs: 0 Atk / 0 Spe<br />
                        - Eruption<br />
                        - Heat Wave<br />
                        - Earth Power<br />
                        - Protect<br /><br />

                        This mini volcano turtle spews big damage when let loose on high HP and under its own sun brought up by Drought. Its low base speed also makes it a good Trick Room Pokémon contender and its ability allow Lilligant to thrive in a non-Trick Room environment. Charcoal was given to it to further boost Eruption’s and Heat Wave’s damage output, and Earth Power was chosen over Solar Beam to have an easier time nuking Coalossal.

                        In terms of defensive calculations, nothing came to mind and we left it as a default 252/252/4 spread.
                      </p>
                      <h3 style={{ textAlign: 'left' }}>Calculations:</h3>
                      <hr />

                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <h4 style={{ textAlign: 'left' }}>Offensive Calcs:</h4>
                        <img alt="sword" src={sword} style={{ width: 40 }} />
                      </div>
                      <p style={{ textAlign: 'left' }}>

                        252+ SpA Charcoal Torkoal Max Flare vs. 252 HP / 0 SpD Dynamax Celesteela in Sun: 380-450 (93.1 - 110.2%) -- 62.5% chance to OHKO<br /><br />

                        252+ SpA Charcoal Torkoal Eruption (150 BP) vs. 0 HP / 4 SpD Dynamax Venusaur in Sun: 284-336 (91.6 - 108.3%) -- 50% chance to OHKO<br /><br />

                        252+ SpA Charcoal Torkoal Eruption (150 BP) vs. 4 HP / 0 SpD Spectrier in Sun: 171-202 (97.1 - 114.7%) -- 81.3% chance to OHKO<br /><br />

                        252+ SpA Torkoal Heat Wave vs. 4 HP / 0 SpD Metagross in Sun: 168-198 (107.6 - 126.9%) -- guaranteed OHKO<br /><br />

                        252+ SpA Charcoal Torkoal Heat Wave vs. 4 HP / 252 SpD Metagross in Sun: 152-180 (97.4 - 115.3%) -- 87.5% chance to OHKO<br /><br />
                      </p>
                      <hr />
                    </TabPanel>
                    <TabPanel>

                      <img alt="lilligant" style={{ display: 'flex', alignSelf: 'left', width: this.state.windowWidth / 4 }} src={lilligant} />

                      <p style={{ textAlign: 'left' }}>

                        <b>Lilligant</b> @ Focus Sash<br />
                        Ability: Chlorophyll<br />
                        Level: 50<br />
                        EVs: 4 HP / 252 SpA / 252 Spe<br />
                        Timid Nature<br />
                        IVs: 0 Atk<br />
                        - Sleep Powder<br />
                        - After You<br />
                        - Leaf Storm<br />
                        - Encore<br /><br />

                        Being the utility champion of the team, Lilligant provides the team with a sleuth of supportive options that can turn the tide of battle. The flower requires at least two hits to faint and allows for Sleep turn disruption via Sleep Powder, a passive move punisher via Encore, a painful damage output via Leaf Storm, and what our team was defined after, After You.

                        After You makes the target move right after its usage if it has not moved during the game turn. The move also ignores the target’s move priority, making immediate Trick Rooms possible, which is great especially in the mid/end game when resetting Trick Room is important. Additionally, due to its ability Chlorophyll, it allows it to outspeed everything in a normal sun environment, allowing it to give immediate pressure to the field.

                        Decked out with these options, it gives the team a lot of dynamic support options to succeed.
                      </p>
                      <h3 style={{ textAlign: 'left' }}>Calculations:</h3>
                      <hr />

                      <p style={{ textAlign: 'left' }}>

                        Faster than non-boosted Venusaur naturally.<br /><br />
                        Faster than non-boosted Regieleki under sun and in a non-Trick Room, non-Tailwind environment.<br /><br />
                        Outspeeds neutral-natured Landorus.<br /><br />

                        After the team was built, I practiced with Lewis up till the day before the competition to fine tune my plays and groove. I was ready, ready to face what Singapore’s best had to offer.<br /><br />
                      </p>
                    </TabPanel>
                  </Tabs>

                </div>
              </Grid>
            </TabPanel>
            <TabPanel>
              <Grid container xs={12} md={10}>

                <div style={{ padding: 64 }}>
                  <h2 style={{ textAlign: 'left' }}><u>Psychic Mayhem</u></h2>
                  <h4 style={{ textAlign: 'left' }}>Lead: Indeedee + Hatterene</h4>
                  <h4 style={{ textAlign: 'left' }}>Back: Torkoal + Lilligant/Mimikyu</h4>
                  <hr />
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <h3 style={{ marginTop: 32, marginBottom: 32, textAlign: 'left' }}>Good against:</h3>
                    <img alt="sword" src={sword} style={{ width: 40 }} />
                  </div>
                  <p style={{ textAlign: 'left' }}>
                    Torkoal + Venusaur<br /><br />
                    Dragapult + Coalossal<br /><br />
                    Incineroar + Rillaboom<br /><br />
                  </p>
                  <hr />
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <h3 style={{ marginTop: 32, marginBottom: 32, textAlign: 'left' }}>Bad against:</h3>

                    <img alt="shield" src={shield} style={{ width: 40 }} />
                  </div>
                  <p style={{ textAlign: 'left' }}>
                    Rock Slide based leads<br /><br />
                    Critical Hit Togekiss<br /><br />
                    Porygon2<br /><br />
                  </p>
                  <hr />
                  <p style={{ textAlign: 'left' }}>

                    This lead gives immediate pressure on the field for those unprepared. If there are no threats that reverse or prevent Trick Room, Trick Room via Hatterene is free together with Indeedee’s Follow Me. If Indeedee were to go down, either Torkoal or Lilligant can be brought in to utilize the remaining Trick Room turns or utilize its speed for utility options respectively.<br /><br />

                    Another fair note is that Lilligant’s After You paired with Trick Room helps out with the endgame if Trick Room turns are over and Torkoal is still at the back.<br /><br />
                  </p>

                  <h2 style={{ textAlign: 'left' }}><u>A Spikey Wall</u></h2>
                  <h4 style={{ textAlign: 'left' }}>Lead: Indeedee + Ferrothorn</h4>
                  <h4 style={{ textAlign: 'left' }}>Back: Mimikyu/Lilligant + Hatterene</h4>
                  <hr />
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <h3 style={{ marginTop: 32, marginBottom: 32, textAlign: 'left' }}>Good against:</h3>
                    <img alt="sword" src={sword} style={{ width: 40 }} />
                  </div>
                  <p style={{ textAlign: 'left' }}>
                    Passive and Stall Teams (I.e. Chansey)<br /><br />
                    Opposing Ferrothorns<br /><br />
                  </p>
                  <hr />
                  <p style={{ textAlign: 'left' }}>
                    The strategy here is to allow Ferrothorn to max out on its Defense stat to abuse Body Press in the endgame. Indeedee and Mimikyu allow it free turns to set up its Defenses and Leech Seed when needed. Hatterene gives much more pressure midgame/endgame due to its big offensive pressure and can help turn the tide if the opponent is caught off guard. I would not recommend Lilligant here but After You onto Ferrothorn would be neat for free KOs. Watch out for Ghost-types as it cripples Body Press. If needed, this combo can also be utilized for a timer stall, especially against Chansey based teams. However, you have to make sure that Leech Seed lands on Chansey to win a 1v1 scenario.
                  </p>
                  <h2 style={{ textAlign: 'left' }}><u>Eruption Go Nyoom</u></h2>
                  <h4 style={{ textAlign: 'left' }}>Lead: Torkoal + Lilligant</h4>
                  <h4 style={{ textAlign: 'left' }}>Back: Mimikyu/Indeedee + Hatterene</h4>
                  <hr />
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <h3 style={{ marginTop: 32, marginBottom: 32, textAlign: 'left' }}>Good against:</h3>
                    <img alt="sword" src={sword} style={{ width: 40 }} />
                  </div>
                  <p style={{ textAlign: 'left' }}>
                    Teams with no Fake Out pressure<br /><br />
                    Glass cannon based leads<br /><br />
                  </p>
                  <hr />
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <h3 style={{ marginTop: 32, marginBottom: 32, textAlign: 'left' }}>Bad against:</h3>
                    <img alt="shield" src={shield} style={{ width: 40 }} />
                  </div>
                  <p style={{ textAlign: 'left' }}>
                    Bulky leads(I.e. Porygon2)<br /><br />
                    Fake Out leads<br /><br />
                    Wide Guard<br /><br />
                  </p>
                  <hr />
                  <p style={{ textAlign: 'left' }}>
                    This lead allows immediate damage output at a glance and punishes those without Fake Out pressure off the bat. It allows for an immediate damage output via Eruption on turn 1 or an RNG-based Sleep Powder.<br /><br />

                    However, it becomes stale midgame so only lead this lead if you are confident nothing can stop Torkoal and Lilligant.<br /><br />

                    Mimikyu is there to aid as a Trick Room setter for Hatterene to sweep endgame.<br /><br />
                  </p>
                  <h2 style={{ textAlign: 'left' }}><u>Other Strategies</u></h2>
                  <h4 style={{ textAlign: 'left' }}>Lead: Lilligant + Hatterene/Mimikyu</h4>
                  <h4 style={{ textAlign: 'left' }}>Back: Torkoal + Anything that supports</h4>
                  <p style={{ textAlign: 'left' }}>
                    Lilligant acts as a threat that should not be ignored. It allows opponents to rethink their strategies straight off game 1 and can help in peculiar situations. The Lilligant-Hatterene lead is scary because a lot of options are laid on the table for the opponent to think about. As for the Mimikyu lead, it allows a Trick Room set up almost for free with Lilligant’s Sleep Powder and After You option, but do keep note that Lilligant has a Focus Sach so only After You-Trick Room if you predict the opponent doubling down into the Lilligant slot.<br /><br />
                  </p>
                </div>
              </Grid>
            </TabPanel>
            <TabPanel>
              <Grid container xs={12} md={10}>

                <div style={{ padding: 64 }}>
                  <h2 style={{ textAlign: 'left' }}>Week 1 Matches (4 Win, 1 Loss), 2nd Place</h2>
                  <hr />
                  <img alt="asiacupplopy" style={{ display: 'flex', alignSelf: 'left', width: this.state.windowWidth / 2 }} src={asiacup_plopy} />
                  <h3 style={{ marginTop: 32, marginBottom: 32, textAlign: 'left' }}>R1: Plopy 2-0 (Win)</h3>
                  <h4 style={{ textAlign: 'left' }}>Lead: Indeedee + Hatterene</h4>
                  <h4 style={{ textAlign: 'left' }}>Back: Torkoal + Lilligant</h4>
                  <p style={{ textAlign: 'left' }}>
                    The match against Plopy was a relatively quick one. Though, I had to quickly target down his Haxorus and Excadrill to prevent Guillotine and Fissure hits.Man, this guy scary..
                  </p>
                  <hr />
                  <img alt="asiacupceles" style={{ display: 'flex', alignSelf: 'left', width: this.state.windowWidth / 2 }} src={asiacup_celes} />
                  <h3 style={{ marginTop: 32, marginBottom: 32, textAlign: 'left' }}>R2: Celes 2-0 (Win)</h3>
                  <h4 style={{ textAlign: 'left' }}>Lead: Indeedee + Hatterene</h4>
                  <h4 style={{ textAlign: 'left' }}>Back: Torkoal + Lilligant</h4>
                  <p style={{ textAlign: 'left' }}>
                    <Tabs>
                      <TabList style={{ textAlign: 'left', alignItems: 'left' }}>
                        <Tab style={{ display: 'flex', alignItems: 'center' }}>
                          <p style={{ marginTop: 'auto', verticalAlign: 'middle', display: 'contents' }}>Team Preview</p>
                        </Tab>
                        <Tab style={{ display: 'flex', alignItems: 'center' }}>
                          <p style={{ marginTop: 'auto', verticalAlign: 'middle', display: 'contents' }}>Game 1</p>
                        </Tab>
                        <Tab style={{ display: 'flex', alignItems: 'center' }}>
                          <p style={{ marginTop: 'auto', verticalAlign: 'middle', display: 'contents' }}>Game 2</p>
                        </Tab>
                      </TabList>
                      <TabPanel>
                        <p style={{ textAlign: 'left' }}>
                          The competition being an open team sheet gave me a slight advantage in my game plans.
                          I noticed that her team did not have a way of dealing with Trick Room apart from Glastrier and thus, I went with the Indeedee + Hatterene lead for both games.
                        </p>
                      </TabPanel>
                      <TabPanel>
                        <p style={{ textAlign: 'left' }}>
                          She Dynamaxed her Zapdos pretty early on in the game and though her Zapdos was Assault Vest, it could not survive the power punched attacks from a Gigantamax Hatterene that had Helping Hand support.<br /><br />
                        </p>
                      </TabPanel>
                      <TabPanel>
                        <p style={{ textAlign: 'left' }}>
                          In game two, Celes adapted by bringing and Dynamaxing Glastrier if I can recall, but it was futile in the face of a Torkoal under Trick Room.<br /><br />
                        </p>
                      </TabPanel>
                    </Tabs>
                  </p>
                  <hr />
                  <img alt="asiacupmelvin" style={{ display: 'flex', alignSelf: 'left', width: this.state.windowWidth / 2 }} src={asiacup_melvin} />
                  <h3 style={{ marginTop: 32, marginBottom: 32, textAlign: 'left' }}>R3: Shaman ~Melvin Keh (<a href="https://www.twitter.com/ShamanVGC" target="_blank" rel="noreferrer">@ShamanVGC</a>) 2-1 (Win)</h3>
                  <h5 style={{ textAlign: 'left' }}><u>Game 1 & 3: </u></h5>
                  <h4 style={{ textAlign: 'left' }}>Lead: Indeedee + Hatterene</h4>
                  <h4 style={{ textAlign: 'left' }}>Back: Torkoal + Lilligant</h4>

                  <h5 style={{ textAlign: 'left' }}><u>Game 2: </u></h5>
                  <h4 style={{ textAlign: 'left' }}>Lead: Indeedee + Mimikyu/Ferrothorn</h4>
                  <h4 style={{ textAlign: 'left' }}>Back: Torkoal + Hatterene</h4>
                  <p style={{ textAlign: 'left' }}>
                    Damn a team kill, but it would have been eventual that I’ll be fighting friends. Melvin, like <b>Zachary Kelly</b> (<a href="https://www.twitter.com/zealpkmn" target="_blank" rel="noreferrer">@zealpkmn</a>), brought a Coalossal team similar to <a href="https://www.twitter.com/supahsanti" target="_blank" rel="noreferrer">@supahsanti</a>’s and having prior practice to this matchup, I went into my games confidently.<br /><br />
                  </p>
                  <Tabs>
                    <TabList style={{ textAlign: 'left', alignItems: 'left' }}>
                      <Tab style={{ display: 'flex', alignItems: 'center' }}>
                        <p style={{ marginTop: 'auto', verticalAlign: 'middle', display: 'contents' }}>Team Preview</p>
                      </Tab>
                      <Tab style={{ display: 'flex', alignItems: 'center' }}>
                        <p style={{ marginTop: 'auto', verticalAlign: 'middle', display: 'contents' }}>Game 1</p>
                      </Tab>
                      <Tab style={{ display: 'flex', alignItems: 'center' }}>
                        <p style={{ marginTop: 'auto', verticalAlign: 'middle', display: 'contents' }}>Game 2</p>
                      </Tab>
                      <Tab style={{ display: 'flex', alignItems: 'center' }}>
                        <p style={{ marginTop: 'auto', verticalAlign: 'middle', display: 'contents' }}>Game 3</p>
                      </Tab>
                    </TabList>
                    <TabPanel>
                      <p style={{ textAlign: 'left' }}>
                        Having practiced against a similar team matchup, I knew the strategies he could play off the bat, especially a 2 turn based play where it allows him to pivot Hatterene out via Parting Shot. <br /><br />
                        Baiting him into the play would be good in Game 1 and doing a different strategy for the subsequent rounds would help with predicting his plays.
                      </p>
                    </TabPanel>
                    <TabPanel>
                      <p style={{ textAlign: 'left' }}>
                        In game 1, he brought in Incineroar and Coalossal, with me leading in Indeedee and Hatterene. Predicting the Coalossal switching out into Rillaboom to overwrite my Psychic Terrain, I Gigantamaxed my Hatterene and utilised a Helping Hand G-max Smite onto Incineroar to pick up a OHKO. This play punished his game plan to Parting Shot my Hatterene and forced bigger pressure.He brought in Coalossal to Dynamax on the next turn and preserved Togekiss in the back slot. Here, he G-max Volcaliths into my Indeedee thanks to Follow Me and I G-max Smite his Rillaboom for a free kill.I then Max Mindstormed into the Togekiss slot to set up Psychic Terrain with a helping hand boost, and finished up the game by using Expanding Force.<br /><br />
                      </p>
                    </TabPanel>
                    <TabPanel>
                      <p style={{ textAlign: 'left' }}>
                        In game 2, I wanted to try something different against him and brought Indeedee and Mimikyu instead of the usual Indeedee, Hatterene lead.He leads with Dragapult and Incineroar, with Rillaboom and Togekiss at the back.Though I was successful in setting Trick Room, I wasted two to three turns on the field passively with Indeedee and Mimikyu.That gave Melvin the upper hand as he could do consistent damage with Dragapult and wither me down using Parting Shot and Fake Out from Incineroar and Rillaboom.Though I could give Dynamax/Gigantamax pressure, the game was overdue to him outspeeding me.Game 3 time.<br /><br />

                      </p>
                    </TabPanel>
                    <TabPanel>
                      <p style={{ textAlign: 'left' }}>
                        In game 3, I went back to my roots and brought the same four as in game 1. Melvin, likewise, does the same but switches his game plan.He predicted that I did not know about the Parting Shot and Magic Bounce interaction.If a Pokémon Parting Shots a Pokémon that has Magic Bounce as its ability, the effects of Parting Shot reverses, where my Hatterene returns to my party to be switched and Incineroar gets a debuff.I uno-reverse him, however, by punishing him with a Follow Me and Trick Room.This left Melvin in a tight spot.He adapts by Gigantamaxing Rillaboom, hoping that Gmax-Drum Solo does the damage required.However, it allowed me to switch a fainted Indeedee into Torkoal and let me steamroll the game thanks to the damage output being done.<br /><br />

                      </p>
                    </TabPanel>
                  </Tabs>
                  <hr />
                  <img alt="asiacupmatthew" style={{ display: 'flex', alignSelf: 'left', width: this.state.windowWidth / 2 }} src={asiacup_matthew} />
                  <h3 style={{ marginTop: 32, marginBottom: 32, textAlign: 'left' }}>R4: Luchist ~Matthew Hui 2-1 (Win)</h3>
                  <h5 style={{ textAlign: 'left' }}><u>Game 1: </u></h5>
                  <h4 style={{ textAlign: 'left' }}>Lead: Indeedee + Ferrothorn</h4>
                  <h4 style={{ textAlign: 'left' }}>Back: Mimikyu + Hatterene</h4>

                  <h5 style={{ textAlign: 'left' }}><u>Game 2 & 3: </u></h5>
                  <h4 style={{ textAlign: 'left' }}>Lead: Torkoal + Lilligant</h4>
                  <h4 style={{ textAlign: 'left' }}>Back: Hatterene + Mimikyu</h4>
                  <p style={{ textAlign: 'left' }}>

                    Oh hey another friend, and he’s brought two ün ün ün regis, Regieleki and Registeel.This team was based on a Japanese player’s team and having seen how Registeel steamrolls games, I automatically shifted focus to setting up my Ferrothorn.<br /><br />

                  </p>
                  <Tabs>
                    <TabList style={{ textAlign: 'left', alignItems: 'left' }}>
                      <Tab style={{ display: 'flex', alignItems: 'center' }}>
                        <p style={{ marginTop: 'auto', verticalAlign: 'middle', display: 'contents' }}>Team Preview</p>
                      </Tab>
                      <Tab style={{ display: 'flex', alignItems: 'center' }}>
                        <p style={{ marginTop: 'auto', verticalAlign: 'middle', display: 'contents' }}>Game 1</p>
                      </Tab>
                      <Tab style={{ display: 'flex', alignItems: 'center' }}>
                        <p style={{ marginTop: 'auto', verticalAlign: 'middle', display: 'contents' }}>Game 2</p>
                      </Tab>
                      <Tab style={{ display: 'flex', alignItems: 'center' }}>
                        <p style={{ marginTop: 'auto', verticalAlign: 'middle', display: 'contents' }}>Game 3</p>
                      </Tab>
                    </TabList>
                    <TabPanel>
                      <p style={{ textAlign: 'left' }}>
                        Somehow, while practicing against different team matchups, we practiced against this team and realised how Ferrothorn was when let to set up for free. <br /><br />
                        Thus, I went in straight for the Ferrothorn setup play, but I failed to realise that Spectrier was the counter to it.
                      </p>
                    </TabPanel>
                    <TabPanel>
                      <p style={{ textAlign: 'left' }}>
                        In game 1, I led in Ferrothorn and Indeedee, with Mimikyu and Hatterene back.The game plan was to put pressure on the field immediately on turn 1 to rival Registeel’s Iron Defense and Body Press; after all, Leech Seed and Iron Barbs will carry Ferrothorn to victory in a 1v1 against Registeel.Matthew leads Spectrier and Moltres and kills Indeedee immediately with a Snarl and Fiery Wrath.I let Mimikyu in for turn 2 and failed to realise that Spectrier carried Taunt, in turn shutting down my Ferrothorn setup options.Taking the opportunity, he swaps out one of his Pokémon for Registeel and allows himself to set up freely.I utilised Hatterene’s Gigantamax to knock out Spectrier, Moltres and Landorus and eventually, we were left with the 1v1 situation I pictured.However, due to Registeel getting buffed up in advance to my Ferrothorn, the game was sealed.<br /><br />
                      </p>
                    </TabPanel>
                    <TabPanel>
                      <p style={{ textAlign: 'left' }}>
                        In game 2, I led in Torkoal and Lilligant, with Hatterene and Mimikyu in the back.This was to punish his Spectrier and Moltres lead with an After You + Eruption.Matthew realises the play I was making.He then protects his Moltres and sacrifices Spectrier to make way for Landorus.This allowed me to utilise Lilligant’s Sleep Powder onto the Landorus slot and allowed me to set up Trick Room for a late-game Gigantamax Hatterene sweep.<br /><br />

                      </p>
                    </TabPanel>
                    <TabPanel>
                      <p style={{ textAlign: 'left' }}>
                        I brought the same Pokémon for Game 3 and he spiced things up by switching his leads to Grimmsnarl and Moltres to hinder Lilligant via Thunder Wave.I do the same thing as game 2 turn 1 to dish out some chip damage while Grimmsnarl went for Light Screen and Moltres protected itself.In turn 2, he manages to Thunder Wave my Lilligant and deals damage to it via Moltres.However, Lilligant manages to land a Sleep Powder on Moltres and Torkoal proceeds to dish out big damage onto his team.The endgame was similar but Lilligant did a lot of work.<br /><br />

                      </p>
                    </TabPanel>
                  </Tabs>
                  <hr />
                  <img alt="asiacupevan" style={{ display: 'flex', alignSelf: 'left', width: this.state.windowWidth / 2 }} src={asiacup_evan} />
                  <h3 style={{ marginTop: 32, marginBottom: 32, textAlign: 'left' }}>R5: Evansmoakvgc ~Evan Weng(<a href="https://www.twitter.com/evansmoakvgc" target="_blank" rel="noreferrer">@evansmoakvgc</a>) 0-2 (Loss)</h3>
                  <h5 style={{ textAlign: 'left' }}><u>Game 1: </u></h5>
                  <h4 style={{ textAlign: 'left' }}>Lead: Indeedee + Ferrothorn</h4>
                  <h4 style={{ textAlign: 'left' }}>Back: Hatterene + Lilligant</h4>

                  <h5 style={{ textAlign: 'left' }}><u>Game 2: </u></h5>
                  <h4 style={{ textAlign: 'left' }}>Lead: Indeedee + Hatterene</h4>
                  <h4 style={{ textAlign: 'left' }}>Back: Ferrothorn + Lilligant</h4>
                  <p style={{ textAlign: 'left' }}>
                    A Singapore tourney would not be complete without bumping into Evan. We’ve been matched against each other pretty frequently in other tourneys and this time it was the first seed. He’s one of the many friends that I find challenging to face as he’s got many tricks up his sleeve, and it wrecks my brain! <br /><br />
                    Evan brought an interesting Japanese team to the tourney which consisted of a Stored Power Cresselia. Stored Power increases by 20 base power for each boosted Stat and can be very scary if left unchecked. His trademark Sylveon was also a consistent disruptor able to Yawn threats into oblivion and do big chip damage via Hyper Voice.<br /><br />
                    At this point in the tourney, we were both guaranteed a slot in the Top 16 qualifiers, and I was mentally tired. So I decided to play a fun game of Pokémon.(Sorry mate!)<br /><br />
                  </p>
                  <Tabs>
                    <TabList style={{ textAlign: 'left', alignItems: 'left' }}>
                      <Tab style={{ display: 'flex', alignItems: 'center' }}>
                        <p style={{ marginTop: 'auto', verticalAlign: 'middle', display: 'contents' }}>Team Preview</p>
                      </Tab>
                      <Tab style={{ display: 'flex', alignItems: 'center' }}>
                        <p style={{ marginTop: 'auto', verticalAlign: 'middle', display: 'contents' }}>Game 1</p>
                      </Tab>
                      <Tab style={{ display: 'flex', alignItems: 'center' }}>
                        <p style={{ marginTop: 'auto', verticalAlign: 'middle', display: 'contents' }}>Game 2</p>
                      </Tab>
                    </TabList>
                    <TabPanel>
                      <p style={{ textAlign: 'left' }}>
                        I was pretty much brain dead at this point, but I led the Ferrothorn lead to rival his setup Cresselia, which surprisingly didn't hold up. <br /><br />
                        I led Indeedee and Hatterene next game to see how he would react to it and scout out his Pokémons' speed using Lilligant.
                      </p>
                    </TabPanel>
                    <TabPanel>
                      <p style={{ textAlign: 'left' }}>
                        In game 1, I led Indeedee, Ferrothorn, Hatterene and Lilligant at the back.I was thinking of letting Ferrothorn set up against Cresselia for a better chance at this match up.However, Sylveon’s Yawn got the better of me and though I managed to confusion stall Landorus and take down Cresselia and Stakataka with the help of Gigantamax Hatterene, I was punished by a Swords Dance boosted Landorus looking for confusion revenge and a neglected coffee induced Sylveon in the endgame.I failed to realise Landorus having Fly and that cost me a lot of set -up.<br /><br />

                      </p>
                    </TabPanel>
                    <TabPanel>
                      <p style={{ textAlign: 'left' }}>
                        In game 2, I led in the classic Indeedee, Hatterene with Ferrothorn and Lilligant at the back to scout out more information about his team.The starting few turns were okay, but a mistake I believe I made in the mid-game was not setting Ferrothorn up with Iron Defense before targeting his Stakataka.Stakataka is an OHKO if Ferrothorn was set up with a single Iron Defense.<br /><br />
                        (Show Calculation) <br /><br />
                        It was Stakataka and Cresselia on the board and having Stakataka live meant that it could do more damage to an ally and give Cresselia a free turn to boost up.The turns went on and he managed to set up Cresselia for the perfect endgame win, with help from his Sylveon through Yawn and Stakataka chip damage, giving him a flawless 5-0 win for the qualifier round.<br /><br />
                      </p>
                    </TabPanel>
                  </Tabs>

                  <hr />

                </div>
              </Grid>
            </TabPanel>
            <TabPanel>
              <Grid container xs={12} md={10}>

                <div style={{ padding: 64 }}>
                  <h2 style={{ textAlign: 'left' }}>Week 2 Matches (2 Win, 2 Loss), 10th Place</h2>
                  <hr />
                  <img alt="asiacupyoko" style={{ display: 'flex', alignSelf: 'left', width: this.state.windowWidth / 2 }} src={asiacup_yoko} />
                  <h3 style={{ marginTop: 32, marginBottom: 32, textAlign: 'left' }}>R1: Yoko (<a href="https://www.twitter.com/yoko_clover" target="_blank" rel="noreferrer">@yoko_clover</a>) 0-2 (Loss)</h3>
                  <h5 style={{ textAlign: 'left' }}><u>Game 1:</u></h5>
                  <h4 style={{ textAlign: 'left' }}>Lead: Indeedee + Hatterene</h4>
                  <h4 style={{ textAlign: 'left' }}>Back: Ferrothorn + Lilligant</h4>
                  <h5 style={{ textAlign: 'left' }}><u>Game 2:</u></h5>
                  <h4 style={{ textAlign: 'left' }}>Lead: Indeedee + Ferrothorn</h4>
                  <h4 style={{ textAlign: 'left' }}>Back: Hatterene + Lilligant</h4>
                  <p style={{ textAlign: 'left' }}>
                    Yoko is an intimidating friend to be paired against. She and her Lapras teams wreak havoc wherever they go and this time, her Lapras had a checkmate move that killed off the Ferrothorn strategy, Fissure. Fissure, though 30% accuracy, ensures an OHKO on any Pokémon as long as it lands most of the time and it itself destroys Ferrothorn considering the probability of Fissure hitting is increased the more I set Ferrothorn up. She also had her own Ferrothorn with the same speed Stats to match my own and I knew it was not going to be an easy match.
                  </p>
                  <Tabs>
                    <TabList style={{ textAlign: 'left', alignItems: 'left' }}>
                      <Tab style={{ display: 'flex', alignItems: 'center' }}>
                        <p style={{ marginTop: 'auto', verticalAlign: 'middle', display: 'contents' }}>Team Preview</p>
                      </Tab>
                      <Tab style={{ display: 'flex', alignItems: 'center' }}>
                        <p style={{ marginTop: 'auto', verticalAlign: 'middle', display: 'contents' }}>Game 1</p>
                      </Tab>
                      <Tab style={{ display: 'flex', alignItems: 'center' }}>
                        <p style={{ marginTop: 'auto', verticalAlign: 'middle', display: 'contents' }}>Game 2</p>
                      </Tab>
                    </TabList>
                    <TabPanel>
                      <p style={{ textAlign: 'left' }}>
                        When it came to team preview, my mindset was to punish a non-defensive lead. Not leading Lapras would mean a good starting game pressure for me and I led Indeedee and Hatterene off the bat. <br /><br />
                        If it goes bad, I would switch to the Ferrothorn setup strategy.
                      </p>
                    </TabPanel>
                    <TabPanel>
                      <p style={{ textAlign: 'left' }}>
                        I brought in Indeedee and Hatterene in the face of Lapras and Incineroar in Game 1. The Indeedee and Hatterene pair was an immediate punish if she led anything else due to the pressure the lead exerts. I set up Trick Room and tried to G-max Smite into the Incineroar slot. However, Lapras’ G-max Resonance was enough to bulk up the entire team and it was ultimately hard to chip away at her team’s HP, losing me Game 1.
                      </p>
                    </TabPanel>
                    <TabPanel>
                      <p style={{ textAlign: 'left' }}>
                        In Game 2, I brought in the Ferrothorn set-up strategy and left Lapras alive up till the end game. It was unfortunate that Fissure hit but it is what it is.
                      </p>
                    </TabPanel>
                  </Tabs>

                  <hr />
                  <h3 style={{ marginTop: 32, marginBottom: 32, textAlign: 'left' }}>R2: Bye</h3>
                  <p style={{ textAlign: 'left' }}>
                    Free lunch break for me!
                  </p>
                  <hr />
                  <img alt="asiacupevan" style={{ display: 'flex', alignSelf: 'left', width: this.state.windowWidth / 2 }} src={asiacup_evan} />
                  <h3 style={{ marginTop: 32, marginBottom: 32, textAlign: 'left' }}>R3: Evansmoakvgc ~ Evan Weng(<a href="https://www.twitter.com/evansmoakvgc" target="_blank" rel="noreferrer">@evansmoakvgc</a>) 2-1 (Win)</h3>
                  <h4 style={{ textAlign: 'left' }}>Lead: Lilligant + Hatterene</h4>
                  <h4 style={{ textAlign: 'left' }}>Back: Ferrothorn + Mimikyu</h4>
                  <p style={{ textAlign: 'left' }}>

                    Dang, we paired again. Evan’s team was a match-up I wish I would never bump into again, but there we were ¯\_(ツ)_/¯. I prepared for the matchup during my downtime and realised that I had to play stall with him in the worst-case scenario. I’m not proud of it, but it had to be done.<br /><br />
                  </p>
                  <Tabs>
                    <TabList style={{ textAlign: 'left', alignItems: 'left' }}>
                      <Tab style={{ display: 'flex', alignItems: 'center' }}>
                        <p style={{ marginTop: 'auto', verticalAlign: 'middle', display: 'contents' }}>Team Preview</p>
                      </Tab>
                      <Tab style={{ display: 'flex', alignItems: 'center' }}>
                        <p style={{ marginTop: 'auto', verticalAlign: 'middle', display: 'contents' }}>Game 1</p>
                      </Tab>
                      <Tab style={{ display: 'flex', alignItems: 'center' }}>
                        <p style={{ marginTop: 'auto', verticalAlign: 'middle', display: 'contents' }}>Game 2</p>
                      </Tab>
                      <Tab style={{ display: 'flex', alignItems: 'center' }}>
                        <p style={{ marginTop: 'auto', verticalAlign: 'middle', display: 'contents' }}>Game 3</p>
                      </Tab>
                    </TabList>
                    <TabPanel>
                      <p style={{ textAlign: 'left' }}>
                        I prepped for this matchup assuming we were going to be matched and I went into all 3 games with the same game plan and Evan did so as well.<br /><br />
                        <h4>As for the game plan:<br /></h4>
                        <hr />
                        <h5 style={{ textAlign: 'left' }}>1. Lead in Lilligant and Hatterene to put immediate pressure against Sylveon and Landorus.<br /></h5>
                        - Lilligant is a big threat that needs to be neutralized as quickly as possible lest it throws Sleep Powders everywhere. Thus, making it bait.<br /><br />
                        <h5 style={{ textAlign: 'left' }}>2. Lilligant can either Leaf Storm or Sleep Powder Sylveon depending on how I want the midgame to be. Leaf Storm will give me an easier time taking down Sylveon to neutralise Yawn and Sleep Powder would hinder its movement.<br /></h5>
                        - Gigantamax Hatterene was required to stall as many buffs a guaranteed Dynamaxed Landorus could get via G-max Smite. This would also prevent Cresselia from getting a free buff.<br /><br />
                        <h5 style={{ textAlign: 'left' }}>3. After Lilligant goes down, bring in Ferrothorn to set up Iron Defense and Leech Seed.<br /></h5>
                        - Setting up Ferrothorn here is vital. Even if it gets hit by Yawn, it would have a free turn to set up Iron Defense. This is the bare minimum it needs to nuke Stakataka if it comes into the field and forces prediction.<br /><br />
                        <h5 style={{ textAlign: 'left' }}>4. Leech Seed must then be successfully landed on Sylveon to kill it gradually. This helps in finishing off Sylveon to delete Yawn pressure.<br /><br /></h5>
                        <h5 style={{ textAlign: 'left' }}>5. When Hatterene goes down, bring in Mimikyu to Swords Dance and Shadow Sneak Cresselia.<br /></h5>
                        - Mimikyu comes in mid-game/end-game to sweep up and punish Cresselia.<br />
                        - Disguise allows it time to Swords Dance and a single Shadow Sneak does about 50% to a non-defense boosted Cresselia.<br />
                        - It stops Cresselia from steamrolling and also provides Trick Room for Ferrothorn to always move ahead of Cresselia.<br /><br />
                        <h5 style={{ textAlign: 'left' }}>6. If Ferrothorn and Cresselia are left in the worst-case scenario, timer stall the match.<br /></h5>
                      </p>
                    </TabPanel>
                    <TabPanel>
                      <p style={{ textAlign: 'left' }}>
                        In game 1, I chose Leaf Storm into Sylveon to do damage to make it easier to knock it out mid-game. Sylveon Hyper Voices and Landorus Max Quakes into Gigantamax Hatterene, giving Lilligant an extra turn to abuse its power. I then chose to Sleep Powder Landorus as its priority would be to kill Lilligant this turn, and that Sylveon could not do much considering its options. The game plan was working out as planned, but Evan managed to do some hard reads by switching in Cresselia into the Stakataka slot to tank my boosted Body Press. He takes the opportunity to Trick Room here to allow Stakataka to Rock Slide flinch, which he hits, allowing Cresselia to set up its Stored Power by one turn in advance. Knowing that +5 Cresselia kills, I gave the game to Evan.<br /><br />
                      </p>
                    </TabPanel>
                    <TabPanel>
                      <p style={{ textAlign: 'left' }}>
                        In game 2, I chose to Sleep Powder and took the L on Lilligant missing it twice. He then manages to kill both Lilligant and Gigantamax Hatterene and forces me against a back wall. It was Ferrothorn and Mimikyu up against the world, but I had to keep trying. I set up Iron Defense with Ferrothorn for it to wall Landorus and prep for Cresselia and Stakataka, and I Swords Dance with Mimikyu, to give myself more of a hit. Turns out that my decision here helped me in turning the situation into a winnable one where Mimikyu managed to land a critical hit on Sylveon, knocking it out. We then landed into the last phase of my game plan and closed it up.<br /><br />
                      </p>
                    </TabPanel>
                    <TabPanel>
                      <p style={{ textAlign: 'left' }}>
                        Lilligant let me down a third time by missing Sleep Powder in Game 3, which was punished by a Quick Attack and Max Airstream. Though this allowed me to bring in Ferrothorn to set up, Evan adapted quickly by switching in Cresselia to boost it earlier. This posed a challenge, but I was able to reach the same endgame.<br /><br />
                      </p>

                    </TabPanel>
                  </Tabs>

                  <hr />
                  <img alt="asiacupbrian" style={{ display: 'flex', alignSelf: 'left', width: this.state.windowWidth / 2 }} src={asiacup_brian} />
                  <h3 style={{ marginTop: 32, marginBottom: 32, textAlign: 'left' }}>R4: AsadaShinoSan ~ Brian Soh(<a href="https://www.twitter.com/bsohsmallspaces" target="_blank" rel="noreferrer">@bsohsmallspaces</a>) 1-2 (Loss)</h3>
                  <h5 style={{ textAlign: 'left' }}><u>Game 1:</u></h5>
                  <h4 style={{ textAlign: 'left' }}>Lead: Indeedee + Hatterene</h4>
                  <h4 style={{ textAlign: 'left' }}>Back: Torkoal + Lilligant</h4>
                  <h5 style={{ textAlign: 'left' }}><u>Game 2 and 3:</u></h5>
                  <h4 style={{ textAlign: 'left' }}>Lead: Mimikyu + Lilligant</h4>
                  <h4 style={{ textAlign: 'left' }}>Back: Torkoal + Hatterene</h4>
                  <p style={{ textAlign: 'left' }}>
                    Brian was my last opponent for the tournament and he gave a pretty good friendly fight for Top 8 Qualifiers. Brian brought a team inspired by William Marks’(@MunkeyVGC) team(https://www.youtube.com/watch?v=XRJJOrK8ekI&ab_channel=ck49) with some changes to fit his playstyle.
                  </p>
                  <Tabs>
                    <TabList style={{ textAlign: 'left', alignItems: 'left' }}>
                      <Tab style={{ display: 'flex', alignItems: 'center' }}>
                        <p style={{ marginTop: 'auto', verticalAlign: 'middle', display: 'contents' }}>Team Preview</p>
                      </Tab>
                      <Tab style={{ display: 'flex', alignItems: 'center' }}>
                        <p style={{ marginTop: 'auto', verticalAlign: 'middle', display: 'contents' }}>Game 1</p>
                      </Tab>
                      <Tab style={{ display: 'flex', alignItems: 'center' }}>
                        <p style={{ marginTop: 'auto', verticalAlign: 'middle', display: 'contents' }}>Game 2</p>
                      </Tab>
                      <Tab style={{ display: 'flex', alignItems: 'center' }}>
                        <p style={{ marginTop: 'auto', verticalAlign: 'middle', display: 'contents' }}>Game 3</p>
                      </Tab>
                    </TabList>
                    <TabPanel>
                      <p style={{ textAlign: 'left' }}>
                        I practiced the match up and felt that it was pretty manageable. There were two leads that came to mind, the first being Indeedee-Hatterene, the other featured Mimikyu-Hatterene, where offensive pressure can be provided from the very start. With my hopes up, we went into battle.

                      </p>
                    </TabPanel>
                    <TabPanel>
                      <p style={{ textAlign: 'left' }}>
                        I led Indeedee-Hatterene together with Torkoal-Lilligant in Game 1, while Brian led Incineroar-Togekiss, with Thundurus and Garchomp at the back. I would say Game 1 was testing the waters, but at that point in time, I did not know what I was doing.<br /><br />

                        I was mentally overwhelmed by my emotions at the time and lost my train of thought mid-game, even letting the timer take hold of a turn. My damage calculations were off too when I misjudged Togekiss’ Dazzling Gleam taking down my Indeedee and allowing Parting Shot onto my Gigantamax Hatterene. It was bad, but it was a slap in the face to wake up and focus.

                      </p>
                    </TabPanel>
                    <TabPanel>
                      <p style={{ textAlign: 'left' }}>
                        I took the time during the turns of Game 1 to rethink my game plan.<br /><br />
                        Deciding on playing a prediction play where I led Mimikyu and Hatterene with a Torkoal and Lilligant back, I went into game 2.
                        If Incineroar and Togekiss were to be led, I can pivot Hatterene out when needed. If not, I could Gigantamax Hatterene on turn 1 whilst I Trick Room. Trick Room is the win condition here and if I can bring it up and deal constant damage during the turns, the game should be in my favor.
                        Brian swapped his lead for Togekiss and Garchomp, Incineroar and Thundurus back which was good.<br /><br />
                        Even though Garchomp had Rock Slide, I was able to set Trick Room up and steam roll using Gigantamax Hatterene and Torkoal. The game plan paid off.<br /><br />
                      </p>
                    </TabPanel>
                    <TabPanel>
                      <p style={{ textAlign: 'left' }}>
                        Game 3 was where things got spicy. I led in the same lead and Brian swapped back to his Game 1 game plan. He Dynamaxes his Togekiss, Max Flares into the Mimikyu slot, and chances a 50% roll kill on the Mimikyu using Incineroar’s Flare Blitz. He gets the roll and knocks it out. It was a very risky big brain move on his part, but damn did that pay off for him. I was able to set up Trick Room with the help of Indeedee switching in. Even though Gigantamax Hatterene put in work in Trick Room, he managed to stall Trick Room turns pretty well and had the endgame all ready, where all it took was a fast Garchomp using Earthquake on my entire team. Closing the game with Garchomp left with 6%-ish HP, I wished Brian all the best and ended my tournament run.
                      </p>
                    </TabPanel>
                  </Tabs>

                </div>
              </Grid>
            </TabPanel>
            <TabPanel>
              <Grid container xs={12} md={10}>

                <div style={{ padding: 64 }}>
                  <h2 style={{ textAlign: 'left' }}>Closing Thoughts</h2>
                  <p style={{ textAlign: 'left' }}>

                    Though I did not make it to the Top 8, I’m still pretty happy with how the team performed. Though arguable that the team on some occasions is, “luck reliant”, the days spent on team building, theory crafting and whacking my brain makes it mentally worth it. Being able to test a team in a live competition setting helps set the bar on how far the team and I can go and I’m glad that our team could pull off every trick in its book. It was fun seeing Pokémon in a competitive light once again.<br /><br />

                    There is much more for me to learn mentally and I’m glad that I was able to come to my senses from a low point to continue braving the storm. Feeling bad about your actions and decisions is all part and parcel, but we have to accept and move on.<br /><br />

                    <b>THANK YOU</b>, for reading this team report! It certainly was not easy scrolling back on message history and recalling events after a few busy weeks of Robotics and Website programming..<br /><br />

                    Time to kick back from this mentally taxing game and await my next chapter in life.<br /><br />

                    Special thanks to <b>Lewis Tan</b> for sticking through as my practice buddy, Unite sessions, and <b>Zachary Kelly</b> for proof reading the report together with Lewis.<br /><br />

                    End~
                  </p>

                </div>
              </Grid>
            </TabPanel>
          </Tabs>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(Home);
